<template>
  <div class="checkbox">
    <input
      :id="fieldId"
      class="checkbox__input"
      :checked="checked"
      type="checkbox"
      @input="(event) => $emit('update:checked', event.target.checked)"
    />
    <label class="checkbox__label" :for="fieldId">
      <span
        class="checkbox__label-box flex-shrink-0"
        :class="{ 'checkbox__label-error': hasError }"
      ></span>
      <!-- ToDo: Refactor link props -->
      <p v-if="link" v-html="label"></p>
      <p v-else>{{ label }}</p>
    </label>
  </div>
</template>

<script>
export default {
  name: 'CheckboxField',
  props: {
    label: {
      type: String,
      default: ''
    },
    fieldId: {
      type: String,
      required: true
    },
    checked: {
      type: Boolean
    },
    link: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:checked']
}
</script>
